export class LocalizedText {
  constructor (params = {}) {
    this.languageCode = params.language_code ? params.language_code : null
    this.value = params.value ? params.value : null
  }
}
